import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import {
  Button,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter
} from '../ui';
import { CopyIcon } from '../ui/Icons';
import { getRecordPreviewLabel } from '../../utils/recordPreviewLabel';

/**
 * DuplicateConfirmModal - Duplicate confirmation modal component
 * Similar to DeleteModal but for duplicate actions
 */
const DuplicateConfirmModal = ({
  // State
  isOpen,
  selectedRecord,
  isLoading,
  entityName,
  
  // Configuration
  tableColumns,
  labels,
  
  // Callbacks
  onClose,
  onConfirm
}) => {
  const { theme } = useTheme();

  if (!isOpen || !selectedRecord) {
    return null;
  }

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      size="sm"
    >
      <ModalHeader onClose={onClose}>
        <div className="flex items-center">
          <div className={`p-2 ${theme.colors.info || theme.colors.secondary || 'bg-blue-500'} rounded-lg mr-3`}>
            <CopyIcon className={`w-6 h-6 ${theme.text.inverse}`} />
          </div>
          <ModalTitle>{labels.duplicateTitle || `Duplicate ${entityName}`}</ModalTitle>
        </div>
      </ModalHeader>
      <ModalContent>
        <p className={`${theme.text.secondary} mb-4`}>
          {labels.duplicateConfirmText}
        </p>
        <div className={`p-4 ${theme.colors.background} rounded-lg border ${theme.border.light}`}>
          <div className={`text-sm ${theme.text.primary} font-medium`}>
            {getRecordPreviewLabel(selectedRecord, tableColumns, entityName)}
          </div>
          {selectedRecord?.code && (
            <div className={`text-xs ${theme.text.muted} mt-1`}>
              Code: {selectedRecord.code}
            </div>
          )}
        </div>
        <div className={`mt-4 p-3 ${theme.colors.warning || 'bg-yellow-50 dark:bg-yellow-900/20'} rounded-lg border ${theme.border.light}`}>
          <p className={`text-xs ${theme.text.secondary}`}>
            <strong>Note:</strong> Files will not be copied to the new record.
          </p>
        </div>
      </ModalContent>
      <ModalFooter>
        <div className="flex space-x-3">
          <Button
            onClick={onClose}
            variant="outline"
            className="flex-1"
            disabled={isLoading}
          >
            {labels.cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
            variant="info"
            className="flex-1"
          >
            {labels.duplicateText || 'Duplicate'}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default DuplicateConfirmModal;

